import { useEffect } from 'react';
import Modal from '../ui/Modal.jsx';

function PolicySection({ section }) {
  return (
    <section className="border-b border-white/10 py-4 last:border-0">
      <h3 className="font-display text-base font-semibold text-white">{section.heading}</h3>
      {section.paragraphs?.map((p) => (
        <p key={p.slice(0, 48)} className="mt-3 text-sm leading-relaxed text-slate-300">
          {p}
        </p>
      ))}
      {section.list?.length ? (
        <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-relaxed text-slate-300">
          {section.list.map((item) => (
            <li key={item.slice(0, 48)}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}

export default function LegalPolicyModal({ open, onClose, policy }) {
  useEffect(() => {
    if (!open) return undefined;

    function onKeyDown(e) {
      if (e.key === 'Escape') onClose();
    }

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!policy) return null;

  return (
    <Modal open={open} onClose={onClose} title={policy.title} wide>
      <p className="text-xs font-medium uppercase tracking-wider text-accent-lime">
        Última actualización: {policy.updatedAt}
      </p>
      <p className="mt-4 text-sm leading-relaxed text-slate-300">{policy.intro}</p>
      <p className="mt-3 rounded-lg border border-amber-500/25 bg-amber-500/10 px-3 py-2 text-xs leading-snug text-amber-100/90">
        Documento elaborado conforme a la Ley 1581 de 2012 y normas complementarias en Colombia. La
        Cooperativa recomienda su revisión jurídica institucional antes de adoptarlo como versión definitiva.
      </p>
      <div className="mt-2 divide-y divide-white/5">
        {policy.sections.map((section) => (
          <PolicySection key={section.heading} section={section} />
        ))}
      </div>
      <div className="mt-6 flex justify-end border-t border-white/10 pt-4">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border border-white/15 bg-white/[0.06] px-4 py-2 text-sm font-semibold text-slate-100 transition hover:bg-white/[0.1]"
        >
          Cerrar
        </button>
      </div>
    </Modal>
  );
}
